import { atom } from 'jotai';
import { Workflow } from '~/atoms/schemas/workflowSchemas';
import { createSSEConnection } from '~/lib/workflows/sseConnection';

export interface WorkflowsState {
  workflows: Workflow[];
  workflowsMap: Map<string, Workflow>;
  isLoading: boolean;
  error: string | null;
  connection: ReturnType<typeof createSSEConnection<Workflow>>;
}

const initialState: WorkflowsState = {
  workflows: [],
  workflowsMap: new Map<string, Workflow>(),
  isLoading: false,
  error: null,
  connection: createSSEConnection<Workflow>(),
};

export const workflowsAtom = atom<WorkflowsState>(initialState);
